import axios from 'axios';
import * as urls from './urls';
import store from '@/store';

let authenticated = !!localStorage.getItem('id_token');

let headers = {
  'Content-Type': 'application/json',
  //   'x-api-key': urls.grepcvAPIKey
}
if (authenticated) {
  headers.Authorization = `Bearer ${localStorage.getItem('id_token')}`
}

//axiosClient
const axiosClient = axios.create({
  baseURL: urls.BASE_API_URL,
  headers: headers,
});

const generateHeader = () => {
  let authenticated = !!localStorage.getItem('id_token');
  // console.log(`authenticated`, authenticated)
  // console.log(`localStorage`, localStorage.getItem('id_token'))
  let headers = {
    'Content-Type': 'application/json',
    'Authorization': "a",
  }
  if (authenticated) {
    headers.Authorization = `Bearer ${localStorage.getItem('id_token')}`
  }
  return headers
}

export const loginUser = async (payload) => {
  return await axiosClient.post(urls.LOGIN_USER(), payload, { headers: generateHeader() });
}

export const claimRequest = async (request_id, auditor_id) => {
  return await axiosClient.put(urls.PUT_CLAIM_REQUEST(request_id, auditor_id), { headers: generateHeader() });
}
export const getAllRosters = async () => {
  return await axiosClient.get(urls.GET_ROSTERS(), { headers: generateHeader() });
}

export const getAllTenants = async () => {
  try {
    return await axiosClient.get(urls.GET_TENANTS(), { headers: generateHeader() });
  } catch (error) {
    // store.dispatch('auth/logout');
  }

}
export const getTeams = async (roster_id, timing_date) => {
  return await axiosClient.get(urls.GET_TEAMS(roster_id, timing_date), { headers: generateHeader() });
}

export const getPlayers = async (roster_id, timing_date) => {
  return await axiosClient.get(urls.GET_PLAYERS(roster_id, timing_date), { headers: generateHeader() });
}



export const getRequest = async (request_id) => {
  return await axiosClient.get(urls.GET_REQUEST(request_id), { headers: generateHeader() });
}

export const getMotionRequest = async (request_id) => {
  return await axiosClient.get(urls.GET_MOTION_REQUEST(request_id), { headers: generateHeader() });
}
export const putMotionRequestTimingDate = async (ctx, request_id, timing_date, auditor_id) => {
  return await axiosClient.put(urls.PUT_MOTION_REQUEST_TIMING_DATE(request_id, auditor_id),
    {
      timing_date: timing_date
    }
    , { headers: generateHeader() });
}
export const putMotionRequest = async (ctx, request_id, payload, auditor_id) => {
  return await axiosClient.put(urls.PUT_MOTION_REQUEST(request_id, auditor_id),
    {
      data: payload
    }
    , { headers: generateHeader() });
}

export const putMotionRequestReview = async (request_id, auditor_id) => {
  return await axiosClient.put(urls.PUT_MOTION_REQUEST_REVIEW(request_id, auditor_id), { headers: generateHeader() });
}

export const putMotionRequestVideorek = async (request_id) => {
  return await axiosClient.put(urls.PUT_VIDEOREK_REQUEST(request_id), { headers: generateHeader() });
}

export const postRosterFacerek = async (roster_id, payload, timing_date) => {
  return await axiosClient.post(urls.POST_ROSTER_FACEREK(roster_id, timing_date), payload, { headers: generateHeader() });
}
export const putRequestReview = async (request_id, auditor_id) => {
  return await axiosClient.put(urls.PUT_REQUEST_REVIEW(request_id, auditor_id), { headers: generateHeader() });
}
export const postPlayerReport = async (request_id, payload, auditor_id) => {
  return await axiosClient.post(urls.POST_PLAYER_REPORT(request_id, auditor_id),
    {
      data: payload,
      type: 'player'
    }

    , { headers: generateHeader() });
}
export const putRequest = async (ctx, request_id, payload, auditor_id) => {
  return await axiosClient.put(urls.PUT_REQUEST(request_id, auditor_id),
    {
      data: payload
    }
    , { headers: generateHeader() });
}
export const putRequestTimingDate = async (ctx, request_id, timing_date, auditor_id) => {
  return await axiosClient.put(urls.PUT_REQUEST_TIMING_DATE(request_id, auditor_id),
    {
      timing_date: timing_date
    }
    , { headers: generateHeader() });
}
export const getTenants = async () => {
  return await axiosClient.get(urls.GET_ALL_REQUESTS + `?period=${selected}&page=${ctx.currentPage}&size=${ctx.perPage}${tenantstring}`, { headers: generateHeader() });
}
export const getRecentRequest = async (ctx, selected, tenant) => {

}

export const getAllRequest = async (ctx, selected, tenant, roster, auditStatus, mode = "", owner = "") => {
  console.log(`mode`, mode)
  // let param = {
  //     ext_race_id: raceSlug,
  //     from: from,
  //     limit: limit,
  //   };

  let tenantstring = tenant > 0 ? `&tenantId=${tenant}` : ``
  let rosterstring = roster > 0 ? `&rosterId=${roster}` : ``
  if (mode == "") {
    return await axiosClient.get(urls.GET_ALL_REQUESTS + `?period=${selected}&page=${ctx.currentPage}&size=${ctx.perPage}${tenantstring}${rosterstring}`, { headers: generateHeader() });
  } else if (mode == "video") {
    return await axiosClient.get(urls.GET_MOTIONIQ_REQUESTS + `/all?period=${selected}&page=${ctx.currentPage}&size=${ctx.perPage}${tenantstring}${rosterstring}`, { headers: generateHeader() });
  } else if (mode == "recentvideo") {
    let ownerid = ""
    if (owner && owner != "") {
      ownerid = `&psowner=${owner}`
    }
    return await axiosClient.get(urls.GET_RECENT_MOTIONIQ_REQUESTS + `/all?period=${selected}&page=${ctx.currentPage}&size=${ctx.perPage}${tenantstring}${rosterstring}&auditStatus=${auditStatus}${ownerid}`, { headers: generateHeader() });
  } else {
    return await axiosClient.get(urls.GET_RECENT_SUBMITTED_REQUESTS + `/all?period=${selected}&page=${ctx.currentPage}&size=${ctx.perPage}${tenantstring}${rosterstring}&auditStatus=${auditStatus}`, { headers: generateHeader() });
  }
}

export const getOwnerRequest = async (ctx, owner_id) => {
  return await axiosClient.get(urls.GET_OWNER_REQUESTS(owner_id), { headers: generateHeader() });
}
export const getOwnerMotionRequest = async (ctx, owner_id) => {
  return await axiosClient.get(urls.GET_OWNER_MOTION_REQUESTS(owner_id), { headers: generateHeader() });
}
export const getNextRequest = async (owner_id, bucket, order, last_id, mode) => {
  return await axiosClient.get(urls.GET_NEXT_REQUEST(owner_id) + "?bucket=" + bucket + "&order=" + order + "&lastid=" + last_id + "&mode=" + mode, { headers: generateHeader() });
}
export const getNextMotionRequest = async (owner_id, bucket, order, last_id) => {
  return await axiosClient.get(urls.GET_NEXT_MOTIONIQ_REQUEST(owner_id) + "?bucket=" + bucket + "&order=" + order + "&lastid=" + last_id, { headers: generateHeader() });
}

export const getNextMotionRequestId = async (owner_id, bucket, order, last_id, offset) => {
  let query = `?bucket=${bucket}`
  //"?bucket=" + bucket + "&order=" + order + "&lastid=" + last_id
  if (order) {
    query += `&order=${order}`
  }
  if (last_id) {
    query += `&lastid=${last_id}`
  }
  if (offset) {
    query += `&offset=${offset}`
  }
  return await axiosClient.get(urls.GET_NEXT_MOTIONIQ_REQUEST_ID(owner_id) + query, { headers: generateHeader() });
}

export const getNextRequestId = async (owner_id, bucket, order, last_id, offset, mode) => {
  let query = `?bucket=${bucket}`
  //"?bucket=" + bucket + "&order=" + order + "&lastid=" + last_id
  if (order) {
    query += `&order=${order}`
  }
  if (last_id) {
    query += `&lastid=${last_id}`
  }
  if (offset) {
    query += `&offset=${offset}`
  }
  if (mode) {
    query += `&mode=${mode}`
  }
  return await axiosClient.get(urls.GET_NEXT_REQUEST_ID(owner_id) + query, { headers: generateHeader() });
}


// WEBPACK FOOTER //
// ./src/api/index.js